import React from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Interested from './components/Interested';
import Submit from '../../components/Submit';

const AdditionalProductsPage = ({
  saveAdditionalProductsForm,
  selectedProducts,
  setSelectedProducts
}) => (
  <Form
    onSubmit={saveAdditionalProductsForm}
    initialValues={selectedProducts}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <Content>
          {({ additionalProductsPageTitle = '', additionalProductsContent1 = '' }) => (
            <div>
              <PageHeading>{additionalProductsPageTitle} </PageHeading>
              <StandardBody>
                <p>{additionalProductsContent1}</p>
              </StandardBody>
              <Interested values={selectedProducts} setSelectedProducts={setSelectedProducts} />
            </div>
          )}
        </Content>

        <Submit />
      </form>
    )}
  />
);

AdditionalProductsPage.propTypes = {
  saveAdditionalProductsForm: PropTypes.func.isRequired
};

export default AdditionalProductsPage;
